import { jsx as e } from "react/jsx-runtime";
import { ToastContainer as t } from "react-toastify";
//#region src/components/notification/NotificationsContainer.tsx
var n = () => /* @__PURE__ */ e("div", {
	className: "notification-container-wrapper",
	children: /* @__PURE__ */ e(t, {
		className: "notification-container",
		stacked: !1,
		limit: 5
	})
});
//#endregion
export { n as default };

//# sourceMappingURL=NotificationsContainer.js.map